// Reveals a fixed mobile CTA between the hero and the final call to action.
class SStickyCta extends HTMLElement {
  #observer;
  #heroPassed = false;
  #endReached = false;

  connectedCallback() {
    const hero = document.getElementById(this.dataset.hero);
    const end = document.getElementById(this.dataset.end);
    if (!hero || !('IntersectionObserver' in window)) return;

    this.#observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        const above = entry.boundingClientRect.top < 0;
        if (entry.target === hero) this.#heroPassed = !entry.isIntersecting && above;
        if (entry.target === end) this.#endReached = entry.isIntersecting || above;
      }
      this.#update();
    });

    this.#observer.observe(hero);
    if (end) this.#observer.observe(end);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }

  #update() {
    const visible = this.#heroPassed && !this.#endReached;
    this.toggleAttribute('data-visible', visible);
    // Hidden state stays out of the tab order and accessibility tree.
    this.inert = !visible;
  }
}

customElements.define('s-sticky-cta', SStickyCta);
